module.exports = __webpack_public_path__ + "static/regulador_prod-4c28f5c4f7d7a4317686d293e2613d2d.png";